// Cores e rótulos do painel "Saldos das UCs" — um lugar só para a tabela, o
// detalhe e os indicadores falarem a mesma língua.

import type { FaixaCobertura, TendenciaSaldo } from './saldosUcs';

export const FAIXA_META: Record<FaixaCobertura, { rotulo: string; descricao: string; chip: string; ponto: string }> = {
  falta: {
    rotulo: 'Abaixo de 1 mês',
    descricao: 'O saldo não paga nem um mês de consumo: a UC entra no próximo ciclo sem lastro.',
    chip: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
    ponto: 'bg-red-500',
  },
  saudavel: {
    rotulo: '1 a 2 meses',
    descricao: 'Faixa saudável de saldo.',
    chip: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
    ponto: 'bg-emerald-500',
  },
  atencao: {
    rotulo: '2 a 3 meses',
    descricao: 'Saldo acima da faixa saudável, ainda abaixo do ponto em que o sistema pausa a UC.',
    chip: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
    ponto: 'bg-amber-500',
  },
  excesso: {
    rotulo: 'Acima de 3 meses',
    descricao: 'Crédito parado: é a faixa em que o sistema pausa a UC. Candidata a reduzir o %.',
    chip: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
    ponto: 'bg-blue-500',
  },
};

/** "Usina Fazenda Morro Agudo 02" → "Morro Agudo 02"; "Usina Cooperativa Centro-Sul - UC 10022969932" → "Centro-Sul 10022969932". */
export function nomeCurtoUsina(nome: string): string {
  return nome
    .replace(/^Usina\s+/i, '')
    .replace(/^(Fazenda|Cooperativa)\s+/i, '')
    .replace(/\s+-\s+UC\s+/i, ' ')
    .trim();
}

export const TENDENCIA_META: Record<TendenciaSaldo, { rotulo: string; simbolo: string; cor: string }> = {
  subindo: { rotulo: 'Subindo', simbolo: '↑', cor: 'text-blue-600 dark:text-blue-400' },
  caindo: { rotulo: 'Caindo', simbolo: '↓', cor: 'text-red-600 dark:text-red-400' },
  estavel: { rotulo: 'Estável', simbolo: '→', cor: 'text-gray-400' },
};
